import * as React from 'react';
import { CreateButton, Loading, Title } from 'react-admin';
import { useCreatePath } from 'react-admin';
import { Link } from 'react-router-dom';
import { Card, CardContent, TableCell, TableRow, TableHead, TableBody, Paper, Table, TableContainer } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import { IFrbsUserRecord } from './types';

const listUserCall = httpsCallable(functions, 'listUserCall');

interface IRecord {
  displayName: string;
  email: string;
  id: string;
  expo: string;
  roles: string;
}

const frbsRec2Record = (fRecs: IFrbsUserRecord[]): IRecord[] => {
  return fRecs.map((fRec: IFrbsUserRecord) => ({
    displayName: fRec.displayName,
    email: fRec.email,
    id: fRec.uid,
    expo: fRec.customClaims?.expo || '',
    roles: JSON.stringify(fRec.customClaims?.roles || {}),
  }));
};

export const UserList = () => {
  const [users, setUsers] = React.useState<IRecord[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const createPath = useCreatePath();

  React.useEffect(() => {
    listUserCall().then(usrs => {
      console.log('Got users ', usrs.data);
      setUsers(frbsRec2Record(usrs.data as IFrbsUserRecord[]));
      setIsLoading(false);
      // setUsers(frbsRec2Record(usersMock));
      // setIsLoading(false);
    });
  }, []);
  if (isLoading) {
    return <Loading />;
  }

  const ppp = createPath({ resource: 'admin-users', type: 'edit', id: '4124213' });
  console.log({ ppp });
  return (
    <Card>
      <Title title="List Users" />
      <CreateButton resource="admin-users" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Edit</TableCell>
                <TableCell>email</TableCell>
                <TableCell>name</TableCell>
                <TableCell>expo</TableCell>
                <TableCell>roles</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((usr: IRecord) => (
                <TableRow key={usr.id}>
                  <TableCell>
                    <Link to={createPath({ resource: 'admin-users', type: 'edit', id: usr.id })}>{usr.id}</Link>
                  </TableCell>
                  <TableCell>{usr.email}</TableCell>
                  <TableCell>{usr.displayName}</TableCell>
                  <TableCell>{usr.expo}</TableCell>
                  <TableCell>{usr.roles}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
